module.exports = __webpack_public_path__ + "inactive.051f07b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/inactive.svg
// module id = 201
// module chunks = 0